(function () {
    angular.module('app')
        .component('labeledListItem', {
            bindings: {
                label: '@?',
                labelClass: '@?'
            },
            template: `
                <span ng-class="$ctrl.labelClass">{{$ctrl.label}}</span>
                <ng-transclude></ng-transclude>
            `,
            transclude: true,
            require: {
                labeledList: '^labeledList'
            },
            controller: labeledListItemController
        });

    labeledListItemController.$inject = ['$scope', '$element', '$window', '$timeout', '$interval'];
    var id = 0;
    function labeledListItemController($scope, $element, $window, $timeout, $interval) {
        id++;
        var ctrl = this;
        ctrl.id = id;
        ctrl.$postLink = function () {
            ctrl.$labelElement = $element.find('> span');
            ctrl.previousWidth = ctrl.$labelElement.width();
            if (ctrl.labelClass) {
                var fontLoadCheck = $interval(function () {
                    if (angular.element('html').is('.fa-events-icons-ready,.fa-events-icons-failed')) {
                        ctrl.$updatePadding();
                        $interval.cancel(fontLoadCheck);
                    }
                }, 100);
            }
            else {
                $timeout(ctrl.$updatePadding, 15);
            }
            ctrl.$window = angular.element($window).on('resize.labeledListItem' + id, function () {
                $scope.$evalAsync(ctrl.$updatePadding);
            })
            $element.on('mutateme.zf.trigger click.zf.accordion keydown.zf.accordion', function () {
                $scope.$evalAsync(ctrl.$updatePadding);
            });
            var accordion = $element.closest('.accordion').on('down.zf.accordion', function () {
                $scope.$evalAsync(ctrl.$updatePadding);
            })
        };

        ctrl.$onDestroy = function () {
            ctrl.labeledList.updatePadding({
                element: $element,
                id: ctrl.id,
                width: 0
            }, true);
            ctrl.$window.off('resize.labeledListItem' + id);
        };

        ctrl.$updatePadding = function () {
            var newWidth = ctrl.$labelElement.width();
            if (newWidth && newWidth !== ctrl.previousWidth) {
                ctrl.labeledList.updatePadding({
                    element: $element,
                    id: ctrl.id,
                    width: newWidth
                });
                ctrl.previousWidth = newWidth;
            }
        }
    }
})();